import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <div class="legal-page" dir="rtl">
      <header class="legal-header">
        <div class="legal-container header-inner">
          <a routerLink="/" class="back-link">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
            חזרה לאפליקציה
          </a>
          <span class="app-brand">Commpare</span>
        </div>
      </header>

      <main class="legal-container main-content">
        <article class="legal-card">
          <div class="card-badge">מדיניות פרטיות</div>
          <h1>מדיניות פרטיות – Commpare</h1>
          <p class="last-updated">עודכן לאחרונה: 14 באוקטובר 2026</p>

          <section>
            <h2>1. מבוא</h2>
            <p>
              אפליקציית <strong>Commpare</strong> ("אנחנו", "האפליקציה") מכבדת את פרטיות המשתמשים שלה ומחויבת להגן על המידע האישי הנאסף בעת השימוש בשירות השוואת סלי הקניות. מסמך זה מפרט איזה מידע נאסף, לשם מה הוא משמש וכיצד אנו שומרים עליו.
            </p>
          </section>

          <section>
            <h2>2. מידע שאנו אוספים</h2>
            <p>בעת השימוש באפליקציה עשוי להיאסף המידע הבא:</p>
            <ul>
              <li>
                <strong>פרטי התחברות עם Google (Google Identity):</strong>
                כאשר תבחרו להתחבר באמצעות חשבון Google, נקבל מ-Google פרטים בסיסיים הכוללים: כתובת אימייל, שם מלא ותמונת פרופיל (אם קיימת), ומזהה משתמש ייחודי. אנו מבקשים אך ורק הרשאות אימות בסיסיות (OpenID Connect / Profile / Email).
              </li>
              <li>
                <strong>נתוני סלי קניות ושימוש:</strong>
                פריטים שהוספתם לסל הקניות, העדפות סניפים ורשתות שיווק, וסלים שמורים או משותפים עם בני משפחה/קבוצות שיצרתם.
              </li>
              <li>
                <strong>קובצי עוגיות (Cookies) ואחסון מקומי:</strong>
                האפליקציה עושה שימוש בעוגיות הפעלה (Session Cookies) וב-LocalStorage לשם שמירת מצב ההתחברות שלך והעדפות תצוגה מקומיות.
              </li>
            </ul>
          </section>

          <section>
            <h2>3. כיצד אנו משתמשים במידע?</h2>
            <p>המידע שנאסף משמש אך ורק למטרות הבאות:</p>
            <ul>
              <li>אימות זהותך ומתן גישה לחשבונך.</li>
              <li>שמירה, סנכרון וניהול של סלי הקניות שלך בין מכשירים שונים.</li>
              <li>מתן אפשרות לשתף סלי קניות עם חברי קבוצה שבחרת.</li>
              <li>שיפור חוויית המשתמש והפעלתו התקינה של השירות.</li>
            </ul>
          </section>

          <section>
            <h2>4. שיתוף מידע עם צדדים שלישיים</h2>
            <p>
              <strong>איננו מוכרים, משכירים או מעבירים את המידע האישי שלך לשום גורם מסחרי, מפרסם או צד שלישי.</strong>
            </p>
            <p>
              המידע שלך לא ייחשף לאף גורם חיצוני, למעט במקרים הבאים:
            </p>
            <ul>
              <li>חברים שהזמנתם באופן יזום לקבוצת סל משותף יוכלו לראות את שם הפרופיל שלכם ואת הפריטים בסל המשותף.</li>
              <li>במידה ונידרש לכך על פי חוק או צו שיפוטי מוסמך.</li>
            </ul>
          </section>

          <section>
            <h2>5. אבטחת מידע</h2>
            <p>
              אנו נוקטים באמצעי אבטחה טכנולוגיים וארגוניים סבירים כדי להגן על המידע האישי מפני גישה בלתי מורשית, שינוי, חשיפה או מחיקה. התקשורת עם השרת מוצפנת בפרוטוקול HTTPS מאובטח.
            </p>
          </section>

          <section>
            <h2>6. זכויות המשתמש ומחיקת מידע</h2>
            <p>
              זכותך לבקש עיון במידע האישי שנשמר אודותיך, תיקונו או מחיקתו המלאה ממערכותינו (כולל מחיקת החשבון וכל סלי הקניות המשויכים).
            </p>
            <p>
              לבקשת מחיקת מידע או לכל שאלה בנושא פרטיות, ניתן לפנות אלינו ישירות בדוא"ל:
              <a href="mailto:orenlevy9@gmail.com" class="contact-email">orenlevy9&#64;gmail.com</a>.
            </p>
          </section>

          <section>
            <h2>7. שינויים במדיניות זו</h2>
            <p>
              אנו עשויים לעדכן מדיניות זו מעת לעת. במקרה של עדכון מהותי, נעדכן את תאריך העדכון האחרון בראש עמוד זה.
            </p>
          </section>

          <footer class="legal-footer">
            <p>Commpare – השוואת סלי קניות ומחירים חכמה</p>
            <div class="footer-links">
              <a routerLink="/terms">תנאי שימוש</a>
              <span>•</span>
              <a routerLink="/">דף הבית</a>
            </div>
          </footer>
        </article>
      </main>
    </div>
  `,
  styles: [`
    .legal-page {
      min-height: 100vh;
      background: #f8fafc;
      color: #1e293b;
      font-family: 'Rubik', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      padding-bottom: 3rem;
    }

    .legal-header {
      background: #ffffff;
      border-bottom: 1px solid #e2e8f0;
      position: sticky;
      top: 0;
      z-index: 10;
    }

    .legal-container {
      max-width: 760px;
      margin: 0 auto;
      padding: 0 1.25rem;
    }

    .header-inner {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 60px;
    }

    .back-link {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      color: #0284c7;
      text-decoration: none;
      font-weight: 500;
      font-size: 0.95rem;
      transition: color 0.15s ease;
    }

    .back-link:hover {
      color: #0369a1;
    }

    .app-brand {
      font-size: 1.25rem;
      font-weight: 700;
      color: #0f172a;
      letter-spacing: -0.02em;
    }

    .main-content {
      margin-top: 2rem;
    }

    .legal-card {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 16px;
      padding: 2.25rem;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.03);
    }

    .card-badge {
      display: inline-block;
      background: #e0f2fe;
      color: #0369a1;
      padding: 0.25rem 0.75rem;
      border-radius: 9999px;
      font-size: 0.825rem;
      font-weight: 600;
      margin-bottom: 0.75rem;
    }

    h1 {
      font-size: 1.85rem;
      font-weight: 800;
      color: #0f172a;
      margin: 0 0 0.5rem 0;
      line-height: 1.25;
    }

    .last-updated {
      color: #64748b;
      font-size: 0.9rem;
      margin-bottom: 2rem;
      padding-bottom: 1rem;
      border-bottom: 1px solid #f1f5f9;
    }

    section {
      margin-bottom: 1.75rem;
    }

    h2 {
      font-size: 1.2rem;
      font-weight: 700;
      color: #1e293b;
      margin: 0 0 0.5rem 0;
    }

    p {
      line-height: 1.65;
      color: #334155;
      margin: 0 0 0.75rem 0;
      font-size: 0.975rem;
    }

    ul {
      margin: 0.5rem 0 1rem 0;
      padding-right: 1.5rem;
      padding-left: 0;
      color: #334155;
    }

    li {
      line-height: 1.6;
      margin-bottom: 0.5rem;
      font-size: 0.975rem;
    }

    .contact-email {
      color: #0284c7;
      font-weight: 600;
      text-decoration: underline;
      direction: ltr;
      display: inline-block;
    }

    .legal-footer {
      margin-top: 2.5rem;
      padding-top: 1.5rem;
      border-top: 1px solid #e2e8f0;
      text-align: center;
      color: #64748b;
      font-size: 0.9rem;
    }

    .legal-footer p {
      margin-bottom: 0.5rem;
      color: #64748b;
    }

    .footer-links {
      display: flex;
      justify-content: center;
      gap: 0.75rem;
      align-items: center;
    }

    .footer-links a {
      color: #0284c7;
      text-decoration: none;
      font-weight: 500;
    }

    .footer-links a:hover {
      text-decoration: underline;
    }

    @media (max-width: 640px) {
      .legal-card {
        padding: 1.5rem;
        border-radius: 12px;
      }
      h1 {
        font-size: 1.5rem;
      }
    }
  `]
})
export class PrivacyPolicyComponent {}
